// extracted by mini-css-extract-plugin
export var arrow = "SideMenu-module--arrow--N6ler";
export var arrowLast = "SideMenu-module--arrowLast--2JNi7";
export var code = "SideMenu-module--code--KS-7W";
export var isActive = "SideMenu-module--isActive--btyl-";
export var lightMenu = "SideMenu-module--lightMenu--CeYeb";
export var menu = "SideMenu-module--menu--VmHHT";
export var menuItem = "SideMenu-module--menuItem--7nGPs";
export var size = "SideMenu-module--size--49S36";
export var titleList = "SideMenu-module--titleList--TbSVu";